import { Component } from '@angular/core';

@Component({
  selector: 'app-joint_responsibility_agreement',
  templateUrl: './joint-responsibility-agreement.component.html',
})
export class JointResponsibilityAgreementComponent {}
